import Cookies from "js-cookie";

jQuery(function ($) {
	const base = "growl-component-exit-popup";

	document.addEventListener("mouseout", e => {
		if (!e.toElement && !e.relatedTarget && !Cookies.get("popup_exit")) {
			$(`.${base}`).addClass(`${base}--show`);
		}
	});

	$(`.${base}__close`).on("click", function () {
		$(`.${base}`).hide();
		Cookies.set("popup_exit", "true", { expires: 30 });
	});
});
